import React from 'react';
import { H2, P } from '../styled/typography';

const SafariInstructions = () => (
  <>
    <H2>Video Recorder - Safari Instructions</H2>
    <P>
      We should link to an answers solution to enable the feature flag - its
      about 3 clicks
    </P>
  </>
);

export default SafariInstructions;
